import * as React from "react"
import classnames from "classnames"
import PropTypes from "prop-types"
import "./paper.scss"

interface Paper extends React.HTMLProps<HTMLDivElement> {
	className?: string
	children: React.ReactNode
}

const Paper: React.FC<Paper> = ({ className, children, ...rest }) => {
	return (
		<div className={classnames("paper", className)} {...rest}>
			{children}
		</div>
	)
}

Paper.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
}

Paper.defaultProps = {
	className: "",
}

export default Paper
